import type { SupportDiagnosticTransport, SupportDiagnosticUploadReceipt, SupportDiagnosticUploadRequest } from '@/types/supportDiagnostic';

export const SUPPORT_DIAGNOSTICS_BUCKET = 'app_guincho_support_diagnostics';

export interface SupportDiagnosticUploadScope {
  companyId: string;
  userId: string;
  deviceId: string;
  requestId: string;
  clientBuild: number;
  kind: 'manual' | 'remote_request' | 'system_automatic';
  eventCount: number;
}

interface SupportDiagnosticStorageClient {
  getUserId(): Promise<string>;
  upload(input: { bucket: string; path: string; body: Uint8Array; contentType: string; metadata: Record<string, string | number> }): Promise<{ path: string }>;
  finalize(input: SupportDiagnosticUploadScope & { diagnosticId: string; path: string; sha512: string; byteLength: number }): Promise<string>;
}

export class SupabaseSupportDiagnosticTransport implements SupportDiagnosticTransport {
  constructor(private readonly storage: SupportDiagnosticStorageClient, private readonly scope: SupportDiagnosticUploadScope) {}

  async uploadExplicit(request: SupportDiagnosticUploadRequest): Promise<SupportDiagnosticUploadReceipt> {
    if (await this.storage.getUserId() !== this.scope.userId) throw new Error('Identidade divergente para diagnóstico.');
    if (request.body.byteLength !== request.byteLength || request.byteLength <= 0) throw new Error('Tamanho do diagnóstico inválido.');
    const fileName = `${request.diagnosticId}.agdiag`;
    const path = `${this.scope.companyId}/${this.scope.userId}/${this.scope.deviceId}/${this.scope.requestId}/${fileName}`;
    const finalize = () => this.storage.finalize({ ...this.scope, diagnosticId: request.diagnosticId, path, sha512: request.sha512, byteLength: request.byteLength });
    let protocol: string;
    try {
      const uploaded = await this.storage.upload({
        bucket: SUPPORT_DIAGNOSTICS_BUCKET, path, body: request.body, contentType: request.contentType,
        metadata: { sha512: request.sha512, bytes: request.byteLength, diagnostic_id: request.diagnosticId, request_id: this.scope.requestId },
      });
      if (uploaded.path !== path) throw new Error('Caminho remoto do diagnóstico diverge.');
    } catch (uploadError) {
      if (this.scope.kind !== 'system_automatic') throw uploadError;
      // A RLS recusa novo upload apos finalize; o recibo valida identidade, caminho, hash e tamanho.
      try { protocol = await finalize(); } catch { throw uploadError; }
      return { diagnosticId: request.diagnosticId, protocol, remotePath: path, sha512: request.sha512, byteLength: request.byteLength };
    }
    protocol = await finalize();
    return { diagnosticId: request.diagnosticId, protocol, remotePath: path, sha512: request.sha512, byteLength: request.byteLength };
  }
}
